/* EVAMATS — główna v2 (grey, 30.09.2026). Zachowanie sekcji evm-hp-*: baner bez końca, rzędy przewijane strzałkami,
   wideo odtwarzane dopiero po kliknięciu, zakładki porównania, suwak przed/po, dodanie akcesorium do koszyka na miejscu,
   przypięty przycisk wyboru auta. Każda sekcja dołącza ten plik — strażnik niżej pilnuje jednego uruchomienia,
   a zdarzenie shopify:section:load (edytor motywu) inicjuje sekcję dodaną lub zmienioną w edytorze.
   Stan początkowy ustawiany synchronicznie; przy „ogranicz ruch” nic się samo nie przewija i nie animuje. */
(function () {
  if (window.__evmHp) return;
  window.__evmHp = true;

  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopMq = window.matchMedia('(min-width: 750px)');
  function reduced() { return reduceMq.matches; }

  /* ---------------- 1. baner bez końca ---------------- */
  function initHero(root) {
    if (root.__evmHp) return;
    root.__evmHp = true;
    var viewport = root.querySelector('.evm-hp-hero__viewport');
    var track = root.querySelector('.evm-hp-hero__track');
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;
    var segs = Array.prototype.slice.call(root.querySelectorAll('.evm-hp-hero__seg'));
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-hp-cta]'));
    var cur = root.querySelector('.evm-hp-hero__cur');
    var count = root.querySelector('.evm-hp-hero__count');
    var pauseBtn = root.querySelector('.evm-hp-hero__pause');
    var ms = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    root.style.setProperty('--hp-autoplay', ms + 'ms');

    if (n < 2) {
      root.classList.add('is-ready', 'no-autoplay');
      playVideos(slides[0]);
      return;
    }

    function cleanClone(node) {
      var c = node.cloneNode(true);
      c.classList.add('is-clone');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      c.removeAttribute('id');
      /* klon nie może udawać bloku w edytorze motywu (ten sam data-shopify-editor-block co oryginał) */
      Array.prototype.slice.call(c.attributes).forEach(function (a) { if (/^data-shopify/.test(a.name)) c.removeAttribute(a.name); });
      Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
      Array.prototype.forEach.call(c.querySelectorAll('img'), function (i) { i.removeAttribute('fetchpriority'); i.setAttribute('loading', 'lazy'); });
      Array.prototype.forEach.call(c.querySelectorAll('a,button'), function (a) { a.setAttribute('tabindex', '-1'); });
      return c;
    }
    track.insertBefore(cleanClone(slides[n - 1]), slides[0]);
    track.appendChild(cleanClone(slides[0]));
    var all = Array.prototype.slice.call(track.children); /* [klon ostatniego, 1..n, klon pierwszego] */

    var pos = 1;
    var inView = true;
    var io = null;
    var settleTimer = null;
    var playing = ms > 0 && !reduced();
    var userPaused = false;
    var hold = false;
    var timer = null;
    var startedAt = 0;
    var remaining = ms;
    /* Nie przewijaj pierwszego kadru, zanim jego obraz rzeczywiście się pokaże.
       Na wolnej sieci sam timer mógł pokazać slajd 2 przed slajdem 1. */
    var firstMedia = slides[0].querySelector('picture img');
    var waitingFirstMedia = !!firstMedia && !firstMedia.complete;
    var firstMediaFallback = null;
    var destroyed = false;

    function real() { return ((pos - 1) % n + n) % n; }
    function paint(p, animate) {
      track.style.transition = animate && !reduced() ? 'transform 0.55s var(--hp-ease)' : 'none';
      track.style.transform = 'translate3d(' + (-p * 100) + '%, 0, 0)';
    }
    /* Kopia na brzegu taśmy jest identyczna z prawdziwym slajdem po przeciwnej stronie, więc „przesiadka” z kopii na prawdziwy
       slajd jest niewidoczna, o ile zachowamy BIEŻĄCE położenie taśmy (także w trakcie animacji), a nie ustawimy pozycję
       docelową na sztywno. 23.10: dawniej drugie kliknięcie strzałki w ciągu 0,55 s po wjeździe na kopię ustawiało pozycję
       i w tym samym kadrze startowało nową animację; przeglądarka nie pokazywała przesiadki i taśma „cofała się” przez cztery
       slajdy (skok banera przy szybkim klikaniu). Wymuszone przeliczenie stylu (offsetWidth) sprawia, że następna animacja
       rusza z nowego miejsca. Gdy taśma jest jeszcze daleko od kopii (kliknięcia wyprzedzają animację), przesiadka nie
       jest możliwa: kliknięcie czeka w `queued` i zostaje wykonane zaraz po dojechaniu. `hard` = taśma stoi, ustawiamy
       pozycję bez animacji.
       05.10 przegląd: przy okazji odblokowujemy właśnie ten slajd (syncHidden), inaczej po przejściu z ostatniego na pierwszy
       widoczny slajd zostawał „inert” i klik w baner nic nie robił. */
    var queued = 0;
    function relocate(hard) {
      if (pos !== 0 && pos !== n + 1) return true;
      var shift = pos === 0 ? n : -n;
      var x = (viewport.getBoundingClientRect().left - track.getBoundingClientRect().left) / viewport.clientWidth;
      var to = x + shift;
      if (to < -0.001 || to > n + 1.001) { if (!hard) return false; to = pos + shift; }
      clearTimeout(settleTimer);
      pos += shift;
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-to * 100) + '%, 0, 0)';
      void track.offsetWidth;
      syncHidden();
      return true;
    }
    /* taśma stanęła na kopii (transitionend albo zapas czasowy): przesiadka i ewentualne kliknięcia, które czekały */
    function settle() {
      clearTimeout(settleTimer);
      relocate(true);
      if (queued) { var q = queued; queued = 0; go(pos + q); }
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });

    /* czytnik ekranu i klawiatura widzą tylko slajd na ekranie (klony zawsze ukryte) */
    function syncHidden() {
      all.forEach(function (s, i) {
        if (s.classList.contains('is-clone')) return;
        var on = i === pos;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
    }
    function update() {
      var r = real();
      segs.forEach(function (s, i) {
        s.classList.toggle('is-active', i === r);
        s.classList.toggle('is-done', i < r);
        s.setAttribute('aria-current', i === r ? 'true' : 'false');
      });
      /* restart paska postępu aktywnego segmentu */
      if (segs[r]) { segs[r].classList.remove('is-active'); void segs[r].offsetWidth; segs[r].classList.add('is-active'); }
      ctas.forEach(function (c) { c.hidden = c.getAttribute('data-hp-cta') !== String(r); });
      if (cur) cur.textContent = String(r + 1);
      syncHidden();
      root.classList.toggle('is-waiting-media', waitingFirstMedia && pos === 1);
      slides.forEach(function (s, i) { if (i === r) playVideos(s); else pauseVideos(s); });
      /* sąsiednie slajdy (i ich klony) ładujemy od razu — przejście nie pokaże pustej ramki */
      [r - 1, r + 1].forEach(function (k) {
        var j = ((k % n) + n) % n;
        [all[j + 1], j === 0 ? all[n + 1] : null, j === n - 1 ? all[0] : null].forEach(function (s) {
          if (s) Array.prototype.forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (im) { im.setAttribute('loading', 'eager'); });
        });
      });
    }

    function go(p, animate) {
      if (animate === undefined) animate = true;
      if (p === pos) return;
      pos = Math.max(0, Math.min(n + 1, p));
      paint(pos, animate);
      clearTimeout(settleTimer);
      /* zapas, gdy transitionend nie przyjdzie (karta w tle, animacje wyłączone); potrzebny tylko po wjeździe na kopię */
      if (pos === 0 || pos === n + 1) settleTimer = setTimeout(settle, animate && !reduced() ? 650 : 0);
      update();
      restartAuto();
    }
    /* 05.10 przegląd: cel liczymy PO powrocie z klona — dwa szybkie kliknięcia strzałki (albo dwuklik) wyprowadzały
       tor poza slajdy i baner stawał się pustym ciemnym polem */
    function step(d) {
      if (!relocate()) { queued += d; return; }
      go(pos + d);
    }
    function next() { step(1); }
    function prev() { step(-1); }
    function goReal(i) {
      queued = 0;
      relocate();
      go(i + 1);
    }

    /* autoprzewijanie z pauzą (przycisk, najechanie, fokus, karta w tle, baner poza ekranem) */
    function stopTimer() { clearTimeout(timer); timer = null; }
    function restartAuto() {
      stopTimer();
      remaining = ms;
      if (playing && !userPaused && !hold && !(waitingFirstMedia && pos === 1)) {
        startedAt = Date.now(); timer = setTimeout(next, remaining);
      }
    }
    function setHold(on) {
      if (!playing || userPaused || hold === on) { hold = on; root.classList.toggle('is-hold', on); return; }
      hold = on;
      root.classList.toggle('is-hold', on);
      if (on) { stopTimer(); remaining = Math.max(0, remaining - (Date.now() - startedAt)); }
      else if (!(waitingFirstMedia && pos === 1)) { startedAt = Date.now(); timer = setTimeout(next, remaining); }
    }
    function syncLive() { if (count) count.setAttribute('aria-live', playing && !userPaused ? 'off' : 'polite'); }
    if (playing) root.classList.add('is-playing'); else root.classList.add('no-autoplay');
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        root.classList.toggle('is-paused', userPaused);
        root.classList.toggle('is-playing', !userPaused);
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.getAttribute('data-label-play') : pauseBtn.getAttribute('data-label-pause'));
        syncLive();
        if (userPaused) stopTimer(); else restartAuto();
      });
    }
    syncLive();
    root.addEventListener('mouseenter', function () { setHold(true); });
    root.addEventListener('mouseleave', function () { setHold(root.contains(document.activeElement)); });
    root.addEventListener('focusin', function () { setHold(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) setHold(root.matches(':hover')); });
    function onVisibility() { setHold(document.hidden || !inView || root.matches(':hover')); }
    document.addEventListener('visibilitychange', onVisibility);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { inView = en.isIntersecting; setHold(!inView || document.hidden || root.matches(':hover')); });
      }, { threshold: 0.25 });
      io.observe(viewport);
    }
    /* obraz banera nie „wyjeżdża” za kursorem przy przeciąganiu myszą */
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    root.querySelector('.evm-hp-hero__arrow--next').addEventListener('click', next);
    root.querySelector('.evm-hp-hero__arrow--prev').addEventListener('click', prev);
    segs.forEach(function (s, i) { s.addEventListener('click', function () { goReal(i); }); });
    function segsMode() {
      var wide = desktopMq.matches;
      segs.forEach(function (s) { if (wide) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1'); });
      var wrap = root.querySelector('.evm-hp-hero__segs');
      if (wrap) { if (wide) wrap.removeAttribute('aria-hidden'); else wrap.setAttribute('aria-hidden', 'true'); }
    }
    segsMode();
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', segsMode);
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    /* przeciągnięcie palcem / myszą; pionowe przewijanie strony zostaje (touch-action: pan-y) */
    var drag = null;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('.evm-hp-hero__arrow')) return;
      queued = 0;
      relocate(true);
      drag = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId, moved: false, w: viewport.clientWidth };
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        drag.moved = true;
        setHold(true);
        try { viewport.setPointerCapture(drag.id); } catch (err) { /* nic */ }
      }
      track.style.transition = 'none';
      track.style.transform = 'translate3d(calc(' + (-pos * 100) + '% + ' + dx + 'px), 0, 0)';
    });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.moved) return;
      var dx = e.clientX - d.x;
      var fast = Math.abs(dx) / Math.max(1, Date.now() - d.t) > 0.45;
      if (dx < -d.w * 0.15 || (fast && dx < -20)) next();
      else if (dx > d.w * 0.15 || (fast && dx > 20)) prev();
      else paint(pos, true);
      setHold(root.matches(':hover'));
      /* klik, który kończy przeciągnięcie, nie otwiera linku slajdu */
      var stopClick = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      viewport.addEventListener('click', stopClick, true);
      /* dotyk po przeciągnięciu nie wysyła kliknięcia — blokada nie może przetrwać do następnego, prawdziwego kliknięcia */
      setTimeout(function () { viewport.removeEventListener('click', stopClick, true); }, 80);
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', function (e) { if (drag && e.pointerId === drag.id) { drag = null; paint(pos, true); } });
    /* 05.10 przegląd: usunięte przesuwanie strzałek nad czat/znaczek (clearArrows). Liczone raz przy jednej pozycji
       przewinięcia, na niskich telefonach (≤ 736 px) podnosiło strzałki o 72–126 px po 2 s, ucinało je u góry obrazu
       i przeskakiwało przy chowaniu paska przeglądarki. Strzałki stoją w miejscu z CSS (telefon: 32 % wysokości). */

    paint(pos, false);
    root.classList.add('is-ready');
    update();
    if (waitingFirstMedia) {
      var finishFirstMedia = function (failed) {
        if (!waitingFirstMedia || destroyed) return;
        waitingFirstMedia = false;
        clearTimeout(firstMediaFallback);
        root.classList.remove('is-waiting-media');
        if (pos !== 1) return;
        if (failed) next(); else requestAnimationFrame(restartAuto);
      };
      firstMedia.addEventListener('load', function () { finishFirstMedia(false); }, { once: true });
      firstMedia.addEventListener('error', function () { finishFirstMedia(true); }, { once: true });
      /* Awaryjnie opuść pusty slajd, gdy połączenie wisi bez load/error. */
      firstMediaFallback = setTimeout(function () { finishFirstMedia(true); }, 30000);
      if (firstMedia.complete) finishFirstMedia(!firstMedia.naturalWidth);
    } else if (firstMedia && firstMedia.complete && !firstMedia.naturalWidth) {
      next();
    } else {
      restartAuto();
    }
    /* Reszta banerów (słaby priorytet, ok. 0,4 MB) dociąga się dopiero po załadowaniu strony, krótko po nim: sąsiedzi aktualnego
       slajdu ładują się od razu (update), ale przy szybkim klikaniu wyprzedzamy ich o kilka slajdów i bez tego widać puste kadry.
       Nie robimy tego na „oszczędzaniu danych” i na wolnych sieciach (2G). */
    function warmUp() {
      if (destroyed) return;
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
      all.forEach(function (s) {
        Array.prototype.forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (im) { im.setAttribute('loading', 'eager'); });
      });
    }
    function afterLoad() { if ('requestIdleCallback' in window) window.requestIdleCallback(warmUp, { timeout: 4000 }); else setTimeout(warmUp, 1500); } /* samo ustawienie atrybutu jest tanie; ciężar niesie sieć, a obrazy są i tak „fetchpriority=low” */
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
    root.__evmHpApi = {
      next: next, prev: prev, go: goReal, real: real,
      /* edytor motywu: wybrany blok pokazujemy i zatrzymujemy przewijanie */
      select: function (i) { queued = 0; hold = true; root.classList.add('is-hold'); stopTimer(); go(i + 1, false); },
      release: function () { setHold(false); },
      destroy: function () { destroyed = true; stopTimer(); clearTimeout(settleTimer); clearTimeout(firstMediaFallback); if (io) io.disconnect(); document.removeEventListener('visibilitychange', onVisibility); }
    };
  }

  function playVideos(slide) {
    if (!slide || reduced()) return;
    var vids = slide.querySelectorAll('video[data-src]');
    Array.prototype.forEach.call(vids, function (v) {
      var want = v.classList.contains('evm-hp-hero__video--m') ? !desktopMq.matches : desktopMq.matches;
      if (v.classList.contains('evm-hp-hero__video--all')) want = true;
      if (!want) { v.pause(); return; }
      if (!v.getAttribute('src')) {
        /* telefon: lżejszy plik 720p; gdy go nie ma — pełny plik (sections/evm-hp-hero.liquid, data-src-full) */
        var full = v.getAttribute('data-src-full');
        if (full) v.addEventListener('error', function () { if (v.getAttribute('src') !== full) { v.setAttribute('src', full); var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); } }, { once: true });
        v.setAttribute('src', v.getAttribute('data-src'));
      }
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { /* autoodtwarzanie zablokowane — zostaje obraz */ });
    });
  }
  function pauseVideos(slide) {
    Array.prototype.forEach.call(slide.querySelectorAll('video'), function (v) { v.pause(); });
  }

  /* ---------------- rzędy przewijane (wideo opinii, akcesoria) ---------------- */
  function initRail(root) {
    if (root.__evmHp) return;
    root.__evmHp = true;
    var list = root.querySelector('.evm-hp-rail__list');
    var prevBtn = root.querySelector('[data-rail-prev]');
    var nextBtn = root.querySelector('[data-rail-next]');
    if (!list || !prevBtn || !nextBtn) return;
    function sync() {
      var max = list.scrollWidth - list.clientWidth - 2;
      prevBtn.disabled = list.scrollLeft <= 2;
      nextBtn.disabled = list.scrollLeft >= max;
    }
    function step(dir) { list.scrollBy({ left: dir * list.clientWidth * 0.9, behavior: reduced() ? 'auto' : 'smooth' }); }
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------------- zdjęcia produktów na ciemnej karcie (01.10) ----------------
     Właściciel: „меньше белого где его быть не должно… адаптивно”. Rozpoznajemy zdjęcie po jego krawędziach:
     ≥ 90 % prawie białych pikseli na obwodzie → packshot na białym tle: białe tło połączone z krawędzią wycinamy
     (zalewanie od brzegów, próg 236, miękka krawędź do 180) i produkt stoi na ciemnym „reflektorze”;
     inaczej → zdjęcie (auto, studio) wypełnia pole bez ramek. Gdy obrazu nie da się przeczytać (inna domena) albo
     wycięcie wygląda podejrzanie (tła < 15 % lub > 95 %), zostaje spokojna jasnoszara podkładka. Wynik na adres zdjęcia
     zapamiętujemy — klon w karuzeli nie liczy drugi raz. */
  var picCache = {};
  function picKind(img) {
    var w = 64;
    var h = Math.max(1, Math.round(w * img.naturalHeight / img.naturalWidth));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data;
    var white = 0, all = 0;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        if (yy > 1 && yy < h - 2 && xx > 1 && xx < w - 2) continue;
        var k = (yy * w + xx) * 4;
        all++;
        if (d[k + 3] < 20 || Math.min(d[k], d[k + 1], d[k + 2]) >= 236) white++;
      }
    }
    return white / all >= 0.9 ? 'cut' : 'photo';
  }
  /* 05.10 przegląd: przy srcset naturalWidth to piksele CSS (np. 179 px na telefonie DPR 3), więc wycięty packshot
     wychodził rozmyty. Rysujemy z pliku w jego prawdziwej rozdzielczości (ten sam adres — z pamięci przeglądarki). */
  function fullSize(img, done) {
    var src = img.currentSrc || img.src;
    var full = new Image();
    full.decoding = 'async';
    full.onload = function () { done(full.naturalWidth ? full : img); };
    full.onerror = function () { done(img); };
    full.src = src;
  }
  function cutOut(img, done) {
    var scale = Math.min(1, 720 / img.naturalWidth);
    var w = Math.round(img.naturalWidth * scale);
    var h = Math.round(img.naturalHeight * scale);
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var id = x.getImageData(0, 0, w, h);
    var d = id.data;
    var n = w * h;
    var bg = new Uint8Array(n);
    var queue = new Int32Array(n);
    var head = 0, tail = 0;
    function light(p) { var k = p * 4; return d[k + 3] < 20 || (d[k] >= 236 && d[k + 1] >= 236 && d[k + 2] >= 236); }
    function seed(p) { if (!bg[p] && light(p)) { bg[p] = 1; queue[tail++] = p; } }
    for (var i = 0; i < w; i++) { seed(i); seed((h - 1) * w + i); }
    for (var j = 0; j < h; j++) { seed(j * w); seed(j * w + w - 1); }
    while (head < tail) {
      var p = queue[head++];
      var px = p % w;
      if (px > 0) seed(p - 1);
      if (px < w - 1) seed(p + 1);
      if (p >= w) seed(p - w);
      if (p < n - w) seed(p + w);
    }
    var removed = tail / n;
    if (removed < 0.15 || removed > 0.95) { done(null); return; }
    for (var q = 0; q < n; q++) {
      var k = q * 4;
      if (bg[q]) { d[k + 3] = 0; continue; }
      /* miękka krawędź: jasny piksel tuż przy wyciętym tle staje się częściowo przezroczysty */
      var qx = q % w;
      var edge = (qx > 0 && bg[q - 1]) || (qx < w - 1 && bg[q + 1]) || (q >= w && bg[q - w]) || (q < n - w && bg[q + w]);
      if (edge) {
        var m = Math.min(d[k], d[k + 1], d[k + 2]);
        if (m >= 180) d[k + 3] = Math.round(Math.min(255, ((255 - m) / 75) * 255));
      }
    }
    x.putImageData(id, 0, 0);
    if (!c.toBlob) { done(c.toDataURL('image/png')); return; }
    c.toBlob(function (blob) { done(blob ? URL.createObjectURL(blob) : null); }, 'image/png');
  }
  function adaptPic(box) {
    var img = box.querySelector('img');
    if (!img || box.__evmPic) return;
    box.__evmPic = true;
    /* klon przejął już gotowy wynik oryginału */
    if (/\bis-(cut|photo|plain)\b/.test(box.className)) { box.classList.remove('is-pending'); return; }
    box.classList.add('is-pending');
    function finish(kind, url) {
      if (url) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.addEventListener('load', function () { box.classList.remove('is-pending'); }, { once: true });
        img.src = url;
      } else {
        box.classList.remove('is-pending');
      }
      box.classList.add('is-' + kind);
    }
    /* wynik (albo obietnica wyniku) na adres zdjęcia — klon karuzeli, który wczyta się w tej samej chwili co oryginał,
       czeka na to samo wycięcie zamiast liczyć je drugi raz (05.10 przegląd: 6 wycięć na 4 zdjęcia) */
    function run() {
      var key = img.currentSrc || img.src;
      var hit = picCache[key];
      if (hit && hit.then) { hit.then(function (res) { finish(res.kind, res.url); }); return; }
      if (hit) { finish(hit.kind, hit.url); return; }
      var kind;
      try { kind = picKind(img); } catch (err) { picCache[key] = { kind: 'plain' }; finish('plain'); return; }
      if (kind === 'photo') { picCache[key] = { kind: 'photo' }; finish('photo'); return; }
      var later = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
      var job = new Promise(function (resolve) {
        later(function () {
          fullSize(img, function (src) {
            try {
              cutOut(src, function (url) { resolve(url ? { kind: 'cut', url: url } : { kind: 'plain' }); });
            } catch (err) { resolve({ kind: 'plain' }); }
          });
        });
      });
      picCache[key] = job;
      job.then(function (res) { picCache[key] = res; finish(res.kind, res.url); });
    }
    img.addEventListener('error', function () { box.classList.remove('is-pending'); }, { once: true });
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }

  /* ---------------- karuzela bez końca (akcesoria, 01.10) ----------------
     Właściciel: „одноэтажный и просто бесконечную карусель которая переключается стрелочками”. Tor: klony ostatnich kart
     przed listą i pierwszych za nią (tyle, ile kart widać), przesunięcie o kartę; po dojściu na klon skok bez animacji na
     prawdziwą kartę. Klony są zwykłymi, klikalnymi kartami (przy końcu listy widać je na stałe), ale bez tabulacji
     i ukryte przed czytnikiem ekranu. Fokus z klawiatury przesuwa tor tak, żeby karta z fokusem była widoczna. */
  function initLoop(root) {
    if (root.__evmHp) return;
    root.__evmHp = true;
    var viewport = root.querySelector('.evm-hp-loop__viewport');
    var track = root.querySelector('.evm-hp-loop__track');
    var prevBtn = root.querySelector('.evm-hp-loop__arrow--prev');
    var nextBtn = root.querySelector('.evm-hp-loop__arrow--next');
    var items = Array.prototype.slice.call(track.children);
    var n = items.length;
    var per = 0, clones = 0, pos = 0, step = 0, moving = false, settleTimer = null, pendingLayout = false;
    Array.prototype.forEach.call(root.querySelectorAll('[data-evm-hp-pic]'), adaptPic);
    if (!n) return;

    /* Galeria leży daleko pod pierwszym ekranem. Zdjęcia dostają URL dopiero blisko sekcji:
       natywne loading=lazy samo pobierało je za wcześnie podczas układania strony. */
    if (root.closest('.evm-hp-gal')) {
      var galleryLoaded = false;
      var galleryObserver = null;
      function loadGallery() {
        if (galleryLoaded) return;
        galleryLoaded = true;
        if (galleryObserver) galleryObserver.disconnect();
        root.querySelectorAll('img[data-hp-gallery-src]').forEach(function (img) {
          img.srcset = img.getAttribute('data-hp-gallery-srcset');
          img.src = img.getAttribute('data-hp-gallery-src');
          img.loading = 'eager';
          img.removeAttribute('data-hp-gallery-srcset');
          img.removeAttribute('data-hp-gallery-src');
        });
      }
      function checkGallery() {
        if (galleryLoaded) return;
        var rect = root.getBoundingClientRect();
        if (rect.top < window.innerHeight + 2000 && rect.bottom > -2000) loadGallery();
      }
      function startGalleryObserver() {
        if (galleryLoaded) return;
        checkGallery();
        if ('IntersectionObserver' in window && !galleryLoaded) {
          galleryObserver = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) loadGallery();
          }, { rootMargin: '2000px 0px' });
          galleryObserver.observe(root);
        }
      }
      root.addEventListener('pointerenter', loadGallery, { once: true });
      root.addEventListener('focusin', loadGallery, { once: true });
      root.addEventListener('touchstart', loadGallery, { once: true, passive: true });
      window.addEventListener('scroll', checkGallery, { passive: true });
      window.addEventListener('resize', checkGallery);
      if (document.readyState === 'complete') setTimeout(startGalleryObserver, 300);
      else window.addEventListener('load', function () { setTimeout(startGalleryObserver, 300); }, { once: true });
    }

    function cloneOf(node) {
      var c = node.cloneNode(true);
      c.classList.add('is-clone');
      c.setAttribute('aria-hidden', 'true');
      /* klon nie może udawać bloku w edytorze motywu (jak cleanClone banera) */
      [c].concat(Array.prototype.slice.call(c.querySelectorAll('*'))).forEach(function (e) {
        Array.prototype.slice.call(e.attributes).forEach(function (a) { if (/^data-shopify/.test(a.name)) e.removeAttribute(a.name); });
      });
      Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
      Array.prototype.forEach.call(c.querySelectorAll('a, button, input, select, textarea'), function (e) { e.setAttribute('tabindex', '-1'); });
      Array.prototype.forEach.call(c.querySelectorAll('.evm-hp-card__msg'), function (m) { m.textContent = ''; m.removeAttribute('role'); m.removeAttribute('aria-live'); });
      return c;
    }
    function perView() { return Math.max(1, parseInt(getComputedStyle(root).getPropertyValue('--per-now'), 10) || 1); }
    /* krok = szerokość karty + odstęp; wysokość strzałek liczy CSS (evm-hp.css, --loop-media-ratio), nie skrypt */
    function measure() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      step = items[0].getBoundingClientRect().width + gap;
    }
    function paint(animate) {
      track.style.transition = animate && !reduced() ? 'transform 0.5s var(--hp-ease)' : 'none';
      track.style.transform = 'translate3d(' + (-(pos + clones) * step) + 'px, 0, 0)';
    }
    function settle() {
      clearTimeout(settleTimer);
      moving = false;
      if (pos >= n) { pos -= n; paint(false); }
      else if (pos < 0) { pos += n; paint(false); }
      if (pendingLayout) { pendingLayout = false; relayout(); }
    }
    function build() {
      Array.prototype.forEach.call(track.querySelectorAll('.is-clone'), function (c) { c.remove(); });
      per = perView();
      var loop = n > per;
      root.classList.toggle('is-static', !loop);
      clones = loop ? per : 0;
      for (var i = 0; i < clones; i++) {
        track.appendChild(cloneOf(items[i % n]));
        track.insertBefore(cloneOf(items[((n - 1 - i) % n + n) % n]), track.firstChild);
      }
      Array.prototype.forEach.call(track.querySelectorAll('.is-clone [data-evm-hp-pic]'), adaptPic);
      if (!loop) pos = 0;
      measure();
      paint(false);
    }
    /* 05.10 przegląd: pozycja tylko w zakresie, w którym za klonami nie ma pustego miejsca (‑klony … n); wcześniej
       dwuklik albo przeciągnięcie przy końcu listy przesuwało tor za klony i przez pół sekundy było widać pustą przerwę */
    function go(to) {
      if (!clones) return;
      if (moving) settle();
      pos = Math.max(-clones, Math.min(n, to));
      paint(true);
      moving = true;
      clearTimeout(settleTimer);
      /* zapas, gdy transitionend nie przyjdzie (karta w tle, „ogranicz ruch”) */
      settleTimer = setTimeout(settle, reduced() ? 0 : 650);
    }
    /* krok od strzałki liczony PO powrocie z klona (inaczej drugi szybki klik celował w miejsce za klonami) */
    function stepBy(d) {
      if (moving) settle();
      go(pos + d);
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });
    prevBtn.addEventListener('click', function () { stepBy(-1); });
    nextBtn.addEventListener('click', function () { stepBy(1); });
    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('.evm-hp-loop__arrow')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); stepBy(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); stepBy(-1); }
    });
    /* przeglądarka przewija kontener z overflow:hidden do elementu z fokusem — cofamy to i przesuwamy tor sami */
    viewport.addEventListener('scroll', function () { if (viewport.scrollLeft) viewport.scrollLeft = 0; });
    track.addEventListener('focusin', function (e) {
      viewport.scrollLeft = 0;
      var li = e.target.closest('.evm-hp-loop__item');
      if (!li || li.classList.contains('is-clone') || !clones) return;
      if (moving) settle();
      var i = items.indexOf(li);
      if (i < pos || i > pos + per - 1) { pos = i < pos ? i : i - per + 1; paint(true); }
    });

    var drag = null;
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
    viewport.addEventListener('pointerdown', function (e) {
      if (!clones || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (moving) settle();
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId, moved: false, dx: 0 };
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
        if (Math.abs(dx) < 8) return;
        drag.moved = true;
        root.classList.add('is-dragging');
        try { viewport.setPointerCapture(drag.id); } catch (err) { /* nic */ }
      }
      drag.dx = dx;
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-(pos + clones) * step + dx) + 'px, 0, 0)';
    });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      root.classList.remove('is-dragging');
      if (!d.moved) return;
      var k = Math.round(-d.dx / step);
      if (!k && Math.abs(d.dx) > 40) k = d.dx < 0 ? 1 : -1;
      k = Math.max(-per, Math.min(per, k));
      if (k) stepBy(k); else paint(true);
      /* klik, który przyjdzie po przeciągnięciu, nie otwiera produktu ani powiększenia zdjęcia (14.10: nasłuch na window, bo
         powiększenie łapie klik na document w fazie przechwytywania — wcześniej niż viewport) */
      function stopClick(ev) { ev.preventDefault(); ev.stopPropagation(); }
      window.addEventListener('click', stopClick, true);
      setTimeout(function () { window.removeEventListener('click', stopClick, true); }, 80);
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', function (e) { if (drag && e.pointerId === drag.id) { drag = null; root.classList.remove('is-dragging'); paint(true); } });

    /* tylko zmiana szerokości przelicza tor; w trakcie przesuwania czekamy na koniec ruchu — 05.10 przegląd: dawniej
       każde wczytane zdjęcie wywoływało przeliczenie i ucinało animację w połowie (tor „skakał” na koniec) */
    var resizeTimer = null;
    var lastWidth = root.clientWidth;
    function relayout() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (moving || drag) { pendingLayout = true; return; }
        if (perView() !== per) build(); else { measure(); paint(false); }
      }, 120);
    }
    window.addEventListener('resize', function () {
      if (root.clientWidth === lastWidth) return; /* pasek przeglądarki na telefonie zmienia tylko wysokość */
      lastWidth = root.clientWidth;
      relayout();
    });
    build();
    root.classList.add('is-ready'); /* bez skryptu: przewijanie palcem z przyciąganiem, bez strzałek (evm-hp.css) */
    root.__evmHpApi = {
      next: function () { stepBy(1); }, prev: function () { stepBy(-1); },
      /* edytor motywu: wybrany blok (zdjęcie galerii) przesuwamy na ekran */
      show: function (li) { var i = items.indexOf(li); if (i < 0 || !clones) return; if (moving) settle(); if (i < pos || i > pos + per - 1) go(i); },
      state: function () { return { pos: pos, per: per, n: n, clones: clones, moving: moving }; }
    };
  }

  /* ---------------- wideo po kliknięciu ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.evm-hp-vid__play');
    if (!btn) return;
    var box = btn.closest('.evm-hp-vid');
    Array.prototype.forEach.call(document.querySelectorAll('.evm-hp-vid video'), function (v) { if (!box.contains(v)) v.pause(); });
    var v = box.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.src = btn.getAttribute('data-src');
      v.controls = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = 'auto';
      var label = btn.getAttribute('aria-label');
      if (label) v.setAttribute('aria-label', label);
      box.appendChild(v);
    }
    box.classList.add('is-playing');
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () { /* użytkownik naciśnie play w kontrolkach */ });
    v.focus({ preventScroll: true });
  });

  /* ---------------- zakładki ---------------- */
  function initTabs(root) {
    if (root.__evmHp) return;
    root.__evmHp = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (!on) Array.prototype.forEach.call(panel.querySelectorAll('video'), function (v) { v.pause(); });
          else Array.prototype.forEach.call(panel.querySelectorAll('[data-evm-hp-ba]'), hintIfVisible);
        }
      });
      if (focus) tab.focus();
    }
    /* 01.10: zdjęcia ukrytych zakładek pobieramy, zanim ktoś kliknie — gdy sekcja zbliża się do ekranu (600 px wcześniej)
       albo gdy palec/kursor/fokus trafi na zakładkę. Z loading=lazy w ukrytym panelu przeglądarka czekała na kliknięcie. */
    function warm(panel) {
      if (!panel) return;
      Array.prototype.forEach.call(panel.querySelectorAll('img[loading="lazy"]'), function (img) {
        if (panel.hidden) img.fetchPriority = 'low'; /* ukryte zakładki nie konkurują z tym, co widać */
        img.loading = 'eager';
      });
    }
    var warmed = false;
    function warmAll() {
      if (warmed) return;
      warmed = true;
      tabs.forEach(function (t) { warm(document.getElementById(t.getAttribute('aria-controls'))); });
    }
    /* Pobierz ukryte porównania 1500 px przed sekcją, a przy dotknięciu/klawiaturze jeszcze wcześniej.
       Bez globalnego pobierania tuż po załadowaniu strony: zdjęcia odległej sekcji nie powinny konkurować
       z banerem i wyszukiwarką. Zapas 1500 px zachowuje płynne przełączanie zakładek. */
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { warmAll(); near.disconnect(); }
      }, { rootMargin: '1500px 0px' });
      near.observe(root);
    } else {
      warmAll();
    }
    tabs.forEach(function (t, i) {
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
        t.addEventListener(ev, function () { warm(document.getElementById(t.getAttribute('aria-controls'))); }, { passive: true });
      });
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });
  }

  /* ---------------- przed / po ---------------- */
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('evm-hp-ba__range')) return;
    var ba = e.target.closest('.evm-hp-ba');
    ba.classList.remove('is-hint');
    ba.classList.add('is-touched');
    ba.style.setProperty('--pos', e.target.value); /* liczba 0–100; CSS przelicza na przesunięcie (bez przesunięć układu) */
  });
  /* suwak „kołysze się” raz, gdy pierwszy raz jest widoczny — pokazuje, że da się go przesunąć.
     05.10 przegląd: ukryte zakładki zajmują teraz miejsce (bez skakania strony), więc obserwator widział też suwaki
     w zamkniętych zakładkach i „kołysał” je niewidocznie; teraz tylko w otwartej zakładce, a zakładka otwarta później
     kołysze swój suwak przy otwarciu (initTabs → hintIfVisible). */
  function hintIfVisible(ba) {
    if (ba.__evmHinted || reduced() || ba.classList.contains('is-touched') || ba.closest('[hidden]')) return;
    var r = ba.getBoundingClientRect();
    var seen = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    if (r.height && seen / r.height > 0.5) { ba.__evmHinted = true; ba.classList.add('is-hint'); }
  }
  function initBa(ba) {
    if (ba.__evmHp) return;
    ba.__evmHp = true;
    ba.addEventListener('animationend', function () { ba.classList.remove('is-hint'); });
    if (reduced() || !('IntersectionObserver' in window)) return;
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio > 0.5) hintIfVisible(ba);
        if (ba.__evmHinted) o.disconnect();
      });
    }, { threshold: [0.5, 0.75] });
    o.observe(ba);
  }

  /* ---------------- akcesoria: dodaj do koszyka bez wychodzenia ze strony ----------------
     Faza przechwytywania (05.10 przegląd): domyślna akcja zatrzymana, ZANIM własny nasłuch Shopify na formularzu
     policzy „Added Product” — inaczej jedno dodanie liczyło się w statystyce dwa razy (formularz + zapytanie). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-evm-hp-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.evm-hp-card__msg');
    var idInput = form.querySelector('input[name="id"]');
    if (!btn || !idInput || btn.getAttribute('aria-busy') === 'true') return;
    var labelEl = btn.querySelector('span') || btn;
    var label = labelEl.textContent;
    btn.setAttribute('aria-busy', 'true');
    labelEl.textContent = form.getAttribute('data-busy') || label;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (!res.ok) {
          labelEl.textContent = label;
          if (msg) { msg.classList.remove('is-ok'); msg.textContent = res.j && res.j.description ? res.j.description : form.getAttribute('data-error'); clearMsg(msg); }
          return;
        }
        labelEl.textContent = form.getAttribute('data-done') || label;
        if (msg) {
          msg.classList.add('is-ok');
          msg.textContent = form.getAttribute('data-added') + ' ';
          var a = document.createElement('a');
          a.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          a.textContent = form.getAttribute('data-cart');
          msg.appendChild(a);
        }
        var html = res.j && res.j.sections && res.j.sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (html && bubble) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        }
        /* PUB_SUB_EVENTS to `const` z global.js — nie ma go w window, więc pytamy o samą nazwę */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'evm-hp', productVariantId: Number(idInput.value) }); } catch (err) { /* motyw bez PubSub */ }
        }
        setTimeout(function () { labelEl.textContent = label; }, 2600);
        clearMsg(msg);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        labelEl.textContent = label;
        if (msg) { msg.classList.remove('is-ok'); msg.textContent = form.getAttribute('data-error'); clearMsg(msg); }
      });
  }, true);
  /* komunikat to dymek nad zdjęciem karty (evm-hp.css) — znika sam, nie zostaje na stałe */
  function clearMsg(msg) {
    if (!msg) return;
    clearTimeout(msg.__evmT);
    msg.__evmT = setTimeout(function () { msg.textContent = ''; msg.classList.remove('is-ok'); }, 5000);
  }

  /* ---------------- przypięty przycisk wyboru auta ---------------- */
  function initSticky(root) {
    if (root.__evmHp) return;
    root.__evmHp = true;
    var btn = root.querySelector('.evm-hp-btn');
    var mode = root.getAttribute('data-action') || 'picker';
    var firstScreen = [];
    var footer = null;
    var seen = new Map();
    var io = null;
    function fixedOwner(el) {
      for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
        if (getComputedStyle(n).position === 'fixed') return n;
      }
      return null;
    }
    /* telefon: pasek omija inne przypięte elementy przy swoich krawędziach (znaczek Trusted Shops wskakuje z opóźnieniem) */
    function avoid() {
      var vw = window.innerWidth;
      var y = window.innerHeight - 12 - btn.offsetHeight / 2;
      var left = 12;
      var right = 12;
      function probe(x, side) {
        var stack = document.elementsFromPoint(x, y);
        for (var i = 0; i < stack.length; i++) {
          if (root.contains(stack[i])) continue;
          var f = fixedOwner(stack[i]);
          if (f && !f.contains(root)) {
            var r = f.getBoundingClientRect();
            if (r.width < vw - 2) {
              if (side === 'r') right = Math.max(right, Math.round(vw - r.left + 8));
              else left = Math.max(left, Math.round(r.right + 8));
            }
          }
          return;
        }
      }
      for (var x = vw - 16; x > vw * 0.6; x -= 20) probe(x, 'r');
      for (var x2 = 16; x2 < vw * 0.4; x2 += 20) probe(x2, 'l');
      root.style.setProperty('--hp-sticky-l', left + 'px');
      root.style.setProperty('--hp-sticky-r', right + 'px');
      /* wąski ekran obok znaczka: bez ikony i mniejsza czcionka, napis zawsze w jednej linii */
      root.classList.toggle('is-narrow', vw - left - right < 300);
    }
    function place() {
      if (!desktopMq.matches) { avoid(); return; }
      /* komputer: pigułka obok czatu, na jego wysokości */
      var chat = document.querySelector('.evm-launch');
      if (!chat) { root.style.removeProperty('--hp-sticky-left'); root.style.removeProperty('--hp-sticky-bottom'); return; }
      var r = chat.getBoundingClientRect();
      if (!r.width) return;
      root.style.setProperty('--hp-sticky-left', Math.round(r.right + 12) + 'px');
      root.style.setProperty('--hp-sticky-bottom', Math.round(window.innerHeight - r.bottom + (r.height - btn.offsetHeight) / 2) + 'px');
    }
    function sync() {
      var anyVisible = false;
      seen.forEach(function (v) { if (v) anyVisible = true; });
      var show = !anyVisible;
      /* strona otwarta w połowie (odświeżenie) — obserwator jeszcze nic nie zgłosił */
      if (!seen.size && firstScreen.length) show = firstScreen.every(function (el) { return el.getBoundingClientRect().bottom < 0; });
      root.classList.toggle('is-shown', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { btn.removeAttribute('tabindex'); place(); } else { btn.setAttribute('tabindex', '-1'); }
    }
    function observe() {
      if (io) io.disconnect();
      seen = new Map();
      firstScreen = [document.getElementById('landing-search-models'), document.querySelector('.evm-hp-hero')].filter(Boolean);
      footer = document.querySelector('footer, .footer, [id*="__footer"]');
      if (!('IntersectionObserver' in window)) { root.classList.add('is-shown'); return; }
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        sync();
      }, { threshold: 0 });
      firstScreen.forEach(function (el) { io.observe(el); });
      if (footer) io.observe(footer);
    }
    observe();
    root.__evmHpApi = { refresh: observe, destroy: function () { if (io) io.disconnect(); } };
    /* 05.10 przegląd: bez sondowania ekranu co 300 ms przy przewijaniu (14 × elementsFromPoint na raz) — przypięte
       elementy nie ruszają się z przewijaniem. Miejsce liczymy przy pokazaniu paska, przy zmianie rozmiaru i dwa razy
       później, gdy czat i znaczek Trusted Shops wczytają się z opóźnieniem. */
    /* pasek adresu telefonu zmienia tylko wysokość okna i wysyła „resize” przy każdym przewinięciu — bez przeliczania (14× elementsFromPoint) */
    var lastInnerW = window.innerWidth, placeRaf = 0;
    window.addEventListener('resize', function () {
      if (!desktopMq.matches && window.innerWidth === lastInnerW) return;
      lastInnerW = window.innerWidth;
      cancelAnimationFrame(placeRaf);
      placeRaf = requestAnimationFrame(place);
    });
    function placeIfShown() { if (root.classList.contains('is-shown')) place(); }
    [1500, 12000].forEach(function (ms) { setTimeout(placeIfShown, ms); });
    /* znaczek / czat dokładany później do <body> — jedno przeliczenie na zmianę, nie na każde przewinięcie */
    if (window.MutationObserver) {
      var placeT = null;
      new MutationObserver(function () { clearTimeout(placeT); placeT = setTimeout(placeIfShown, 300); }).observe(document.body, { childList: true });
    }
    if (mode === 'scroll') {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById('landing-search-models');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        var spot = target.querySelector('[data-evm-cs-open="manual"]') || target;
        spot.classList.remove('evm-hp-highlight');
        void spot.offsetWidth;
        spot.classList.add('evm-hp-highlight');
        setTimeout(function () { spot.classList.remove('evm-hp-highlight'); try { spot.focus({ preventScroll: true }); } catch (err) { spot.focus(); } }, reduced() ? 0 : 700);
      });
    }
    sync();
  }

  function initAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-hero]'), initHero);
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-rail]'), initRail);
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-loop]'), initLoop);
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-tabs]'), initTabs);
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-sticky]'), initSticky);
    Array.prototype.forEach.call(s.querySelectorAll('[data-evm-hp-ba]'), initBa);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    /* przypięty przycisk obserwuje baner — po przerysowaniu sekcji w edytorze trzeba obserwować nowy węzeł */
    Array.prototype.forEach.call(document.querySelectorAll('[data-evm-hp-sticky]'), function (s) { if (s.__evmHpApi) s.__evmHpApi.refresh(); });
  });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-evm-hp-hero], [data-evm-hp-sticky]'), function (r) { if (r.__evmHpApi && r.__evmHpApi.destroy) r.__evmHpApi.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var slide = el.closest && el.closest('.evm-hp-hero__slide');
    var hero = el.closest && el.closest('[data-evm-hp-hero]');
    if (slide && hero && hero.__evmHpApi) {
      var real = Array.prototype.filter.call(slide.parentElement.children, function (c) { return !c.classList.contains('is-clone'); });
      hero.__evmHpApi.select(real.indexOf(slide));
      return;
    }
    var loopRoot = el.closest && el.closest('[data-evm-hp-loop]');
    if (loopRoot && loopRoot.__evmHpApi && loopRoot.__evmHpApi.show) { loopRoot.__evmHpApi.show(el.closest('.evm-hp-loop__item')); return; }
    if (el.getAttribute && el.getAttribute('role') === 'tab') { el.click(); return; }
    if (el.tagName === 'DETAILS') { el.open = true; var outer = el.parentElement && el.parentElement.closest('details'); if (outer) outer.open = true; }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('[data-evm-hp-hero]');
    if (hero && hero.__evmHpApi) hero.__evmHpApi.release();
  });
})();
